import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  additionalTargets: hasMany('newsletter-target', { inverse: null }),
  primaryTarget: belongsTo('newsletter-target', { inverse: null }),
});
